module.exports = __webpack_public_path__ + "static/bg-8d719e0a4460955b853f8cba1231bd36.jpg";